import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';
import { RoleControlMenu } from 'app/pages/role-control-menu';
import { MenuPermissionService } from 'app/shared/services/menu-permissions/menu-permission.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private authService: AuthService, private menuPermissions: MenuPermissionService,
                private router: Router) { }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const componentPath = childRoute.url[0] ? childRoute.url[0].path : "";

        const menuItem = RoleControlMenu.find(r => r.Name?.toLowerCase() === componentPath.toLowerCase());
        if (menuItem && menuItem.IsVisible === false) {
            this.router.navigateByUrl('/notAuthorized');
            return false;
        }

        // Same path -> permission rule the sidebar and the shell's screen search apply, see
        // MenuPermissionService.
        if (!this.menuPermissions.isPathAllowed(componentPath)) {
            this.router.navigateByUrl('/notAuthorized');
            return false;
        }
        return true;
    }

    /**
     * Use it to check if user is logged in and has permission
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const url: string = state.url;
        if (url.startsWith('/callback') || url.startsWith('/silent') || this.authService.user) {
            // Bypass activation check
            return Promise.resolve(true);
        } else if (!this.authService.user) {
            this.authService.signinRedirect();
            return Promise.resolve(false);
        }
        else {
            var componentPath = state.url.split('/');
            if (!this.menuPermissions.isPathAllowed(componentPath[componentPath.length - 1])) {
                this.router.navigateByUrl('/notAuthorized');
                return;
            }
        }


    }
}
